// extracted by mini-css-extract-plugin
module.exports = {"content":"MoreFilters_content__2aQ63","header":"MoreFilters_header__2CeqR","body":"MoreFilters_body__3inj_","footer":"MoreFilters_footer__3B6CY","title":"MoreFilters_title__1SfZz"};